import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';

export default function Login() {
  const { login } = useAuth();
  const [step, setStep] = useState('credentials');
  const [form, setForm] = useState({ email: '', password: '' });
  const [mfaCode, setMfaCode] = useState('');
  const [sessionToken, setSessionToken] = useState('');
  const [mfaMethod, setMfaMethod] = useState('EMAIL');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCredentials = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await api.post('/auth/login', form);
      setSessionToken(data.session_token);
      setMfaMethod(data.mfa_method);
      if (data.debug_code) setMfaCode(data.debug_code);
      setStep('mfa');
    } catch (err) {
      setError(err.response?.data?.detail || 'Email ou mot de passe incorrect');
    } finally { setLoading(false); }
  };

  const handleMfa = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const { data } = await api.post('/auth/verify-mfa', { session_token: sessionToken, code: mfaCode });
      login(data.access_token, data.role);
    } catch (err) {
      setError(err.response?.data?.detail || 'Code invalide ou expiré');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <img
            className="login-logo-img"
            src="/logo-ecf.png"
            alt="Logo ECF"
          />
          {/* Fallback si le logo ne charge pas */}
          <div style={{ display: 'none', fontWeight: 900, fontSize: '2rem',
                        color: 'var(--ecf-blue)', letterSpacing: 4 }}>ECF</div>
          <div className="login-app-name">Analyse des bilans</div>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        {step === 'credentials' ? (
          <form onSubmit={handleCredentials}>
            <div className="form-group">
              <label className="form-label">Adresse email</label>
              <input className="form-input" type="email" value={form.email}
                onChange={e => setForm({ ...form, email: e.target.value })}
                placeholder="votre@email.fr" required autoFocus />
            </div>
            <div className="form-group" style={{ marginBottom: 24 }}>
              <label className="form-label">Mot de passe</label>
              <input className="form-input" type="password" value={form.password}
                onChange={e => setForm({ ...form, password: e.target.value })}
                placeholder="••••••••••••" required />
            </div>
            <button className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: '12px 20px' }}
              disabled={loading}>
              {loading ? 'Connexion...' : 'Se connecter'}
            </button>
          </form>
        ) : (
          <form onSubmit={handleMfa}>
            <div style={{ textAlign: 'center', marginBottom: 20, color: 'var(--ecf-grey)',
                          fontSize: '0.85rem', lineHeight: 1.7 }}>
              {mfaMethod === 'EMAIL'
                ? 'Un code de vérification a été envoyé à votre adresse email.'
                : 'Entrez le code de votre application TOTP (Google Authenticator).'}
            </div>
            <div className="form-group" style={{ marginBottom: 24 }}>
              <label className="form-label">Code de vérification</label>
              <input className="form-input" type="text" maxLength={6} value={mfaCode}
                onChange={e => setMfaCode(e.target.value.replace(/\D/g, ''))}
                placeholder="000000"
                style={{ textAlign: 'center', fontSize: '1.8rem', letterSpacing: 14, fontWeight: 800 }}
                required autoFocus />
            </div>
            <button className="btn btn-primary"
              style={{ width: '100%', justifyContent: 'center', padding: '12px 20px' }}
              disabled={loading}>
              {loading ? 'Vérification...' : 'Valider'}
            </button>
            <button type="button" className="btn btn-outline"
              style={{ width: '100%', justifyContent: 'center', marginTop: 8 }}
              onClick={() => { setStep('credentials'); setError(''); setMfaCode(''); }}>
              ← Retour
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
